// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import "@hotwired/stimulus"
import "stylesheets/app"

// require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("jquery-ui")
require("webpack-jquery-ui/datepicker")
require('webpack-jquery-ui/css');
require('jquery-ui/ui/i18n/datepicker-de');

window.jQuery = $;
window.$ = $;

// require('./nested_forms/addFields')
// require('./nested_forms/removeFields')

require('@fortawesome/fontawesome-free/js/all')

require("trix")

import 'bootstrap'

import * as bootstrapValidate from 'bootstrap-validate';
window.bootstrapValidate = bootstrapValidate;

require("moment/locale/de")

require('slick-carousel')
require('bootstrap-select')
require("tempusdominus-bootstrap-4")

import 'controllers'

// import CookiesEuBanner from 'cookies-eu-banner/dist/cookies-eu-banner.min.js'
import '../add_third_party_services_after_consent'


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
document.addEventListener("turbo:load", function() {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
  })
})